const siteURL = 'http://www.dev.mealwell.com/';
const backURL = 'http://api.dev.mealwell.com/';

const config = {
  siteURL,
  backURL,
  apiURL: `${backURL}api/v1/`,
  pdfURL: `${backURL}api/v1.1/pdf-products`
};

export default config;




